document.addEventListener('DOMContentLoaded', function() {
  const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

  const onCartItemsChange = event => {
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    const currVariantId = event.target.closest('.cart-item').dataset.variantId;
    const currCordLength = event.target.closest('.cart-item').dataset.cordLength;
    const targetElement = cartItems.querySelector(`[data-add-on-ref-variant-id="${currVariantId}"][data-cord-length="${currCordLength}"]`);

    if (!targetElement) return;

    setTimeout(() => {
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      const currVariantId = event.target.closest('.cart-item').dataset.variantId;
      const currCordLength = event.target.closest('.cart-item').dataset.cordLength;
      const targetElement = cartItems.querySelector(`[data-add-on-ref-variant-id="${currVariantId}"][data-cord-length="${currCordLength}"]`);
      const qtyInput = targetElement.querySelector('input.quantity__input');
      
      qtyInput.value = event.target.value;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }, 2500);
  };
  
  cartItems.addEventListener('change', onCartItemsChange);

  window.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const add = () => {
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems.classList.contains('is-empty')) {
        setTimeout(() => {
          add();
        }, 600);
        return;
      }

      cartItems.removeEventListener('change', onCartItemsChange);
      cartItems.addEventListener('change', onCartItemsChange);
    };

    add();
  });
});